/* istanbul ignore file */
import OneClick from 'infrastructure/security/authentication/OneClick';
import { Route } from 'framework/routing';
import isOneClickEnabled from 'infrastructure/security/authentication/OneClick/isOneClickEnabled';
import AzureCallbackPage from 'infrastructure/security/authentication/azure/AzureCallbackPage';
import { AZURE_CALLBACK_PATH, AZURE_LOGOUT_PATH, ONE_CLICK_PATH } from './authenticationRouting';

const AuthenticationRouter = () =>
  [
    isOneClickEnabled() && <Route key={ONE_CLICK_PATH} path={ONE_CLICK_PATH} element={<OneClick />} />,
    <Route key={AZURE_LOGOUT_PATH} path={AZURE_LOGOUT_PATH} element={null} />,
    <Route key={AZURE_CALLBACK_PATH} path={AZURE_CALLBACK_PATH} element={<AzureCallbackPage />} />,
  ].filter(Boolean);

export default AuthenticationRouter;
